import { useQuery } from '@tanstack/react-query'

import { api } from '@/clients/api'

export function useFetchFeatureFlags(countryCode: string) {
  return useQuery({
    queryKey: ['featureFlags', countryCode],
    queryFn: async () => {
      const response = await api.featureFlags.get({
        countryCode,
      })

      return response.data
    },
  })
}
